import { useState } from 'react';
import {
  AddBalance,
  Button,
  Card,
  Modal,
  WithdrawModal,
} from '@/components/generic';
import { useTranslation } from 'react-i18next';

export const WalletActions = () => {
  const { t } = useTranslation();
  const [isAddBalance, setIsAddBalance] = useState(false);
  const [isWithdrawModalOpen, setIsWithdrawModalOpen] = useState(false);

  return (
    <>
      <Card title={t('wallet.actions')}>
        <div className='flex gap-3'>
          <Button
            onClick={() => setIsAddBalance(true)}
            className='flex-1 !px-0 gap-3'
            icon={'clock'}
            isStroke
          >
            {t('wallet.deposit')}
          </Button>
          <Button
            className='flex-1 !px-0 gap-3'
            icon={'bag'}
            isStroke
            onClick={() => setIsWithdrawModalOpen(true)}
          >
            {t('wallet.withdraw')}
          </Button>
        </div>
      </Card>
      <Modal
        className=''
        open={isAddBalance}
        onClose={() => setIsAddBalance(false)}
      >
        <AddBalance />
      </Modal>
      <WithdrawModal
        open={isWithdrawModalOpen}
        onClose={() => setIsWithdrawModalOpen(false)}
      />
    </>
  );
};
